// GENERATED FILE - DO NOT MODIFY
export enum ProgressionType {
    Quantity = "Q",
    Rate = "T",
}

export let nameof = "ProgressionType";
